module.exports = __webpack_public_path__ + "img/user_edit.340b6d3d.svg";